import { render, staticRenderFns } from "./SafeForWork4.vue?vue&type=template&id=72a7dd06&scoped=true&"
import script from "./SafeForWork4.vue?vue&type=script&lang=js&"
export * from "./SafeForWork4.vue?vue&type=script&lang=js&"
import style0 from "./SafeForWork4.vue?vue&type=style&index=0&id=72a7dd06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a7dd06",
  null
  
)

export default component.exports